const etagMap = new Map();

export function setEtag(url: string, etag: string) {
  etagMap.set(url, etag);
}

export function getEtag(url: string) {
  return (etagMap.get(url) as string) ?? '';
}
